<ng-container *ngFor="let tax of taxonomies">
    <span class="chip">{{api.taxonomies[tax]?.name}}</span>
</ng-container>